/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmi_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. The 18.5–24.9 'normal' range only applies to adults. Children and teens are assessed with age- and sex-specific BMI-for-age percentile charts, since healthy body composition changes a lot as kids grow. Ask a pediatrician if you need to check a child's growth.`)
};

const es_bmi_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. El rango 'normal' de 18,5–24,9 solo se aplica a adultos. Los niños y adolescentes se evalúan con gráficos de percentiles de IMC por edad y sexo, ya que la composición corporal saludable cambia mucho según crecen los niños. Consulta a un pediatra si necesitas verificar el crecimiento de un niño.`)
};

const de_bmi_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Der Bereich 18,5–24,9 'normal' gilt nur für Erwachsene. Kinder und Jugendliche werden mit alters- und geschlechtsspezifischen BMI-für-Alter-Perzentil-Diagrammen bewertet, da sich die gesunde Körperzusammensetzung während des Wachstums viel verändert. Fragen Sie einen Kinderarzt, wenn Sie die Wachstumskurve eines Kindes überprüfen müssen.`)
};

const nl_bmi_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. Het bereik 18,5–24,9 'normaal' geldt alleen voor volwassenen. Kinderen en tieners worden beoordeeld met leeftijds- en geslacht-specifieke BMI-voor-leeftijdspercentielgrafiekjes, omdat gezonde lichaamsstelling veel verandert naarmate kinderen groeien. Vraag een kinderarts als u de groei van een kind moet controleren.`)
};

const fr_bmi_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. La plage « normale » de 18,5-24,9 ne s'applique qu'aux adultes. Les enfants et les adolescents sont évalués avec des courbes d'IMC selon l'âge et le sexe, car la composition corporelle saine change beaucoup à mesure que les enfants grandissent. Consultez un pédiatre si vous devez vérifier la croissance d'un enfant.`)
};

const it_bmi_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. L'intervallo 'normale' da 18,5–24,9 si applica solo agli adulti. Bambini e adolescenti vengono valutati con grafici percentili BMI per età e sesso, poiché la composizione corporea sana cambia molto durante la crescita. Chiedi a un pediatra se devi controllare la crescita di un bambino.`)
};

const pt_br2_bmi_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. A faixa 'normal' de 18,5–24,9 se aplica apenas a adultos. Crianças e adolescentes são avaliados com gráficos de percentis de BMI-para-idade específicos por sexo e idade, já que a composição corporal saudável muda muito conforme as crianças crescem. Pergunte a um pediatra se você precisar verificar o crescimento de uma criança.`)
};

const pt_bmi_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. O intervalo 'normal' de 18,5–24,9 aplica-se apenas a adultos. Crianças e adolescentes são avaliados com gráficos de percentil de IMC específicos por idade e sexo, uma vez que a composição corporal saudável muda muito à medida que as crianças crescem. Pergunte a um pediatra se precisar de verificar o crescimento de uma criança.`)
};

const ja_bmi_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。18.5～24.9の「普通」範囲は成人にのみ適用されます。子どもと十代の若者は、子どもの成長に応じて健康的な体組成が大きく変わるため、年齢別および性別別のBMI-age百分位数チャートで評価されます。子どもの成長を確認する必要がある場合は、小児科医に相談してください。`)
};

const zh_bmi_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不适用。18.5–24.9 的“正常”范围仅适用于成年人。儿童和青少年需要使用按年龄和性别划分的 BMI 年龄百分位曲线图进行评估，因为健康的身体成分会随着孩子的成长发生很大变化。如需评估孩子的生长发育情况，请咨询儿科医生。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmi_hub_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmi_hub_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmi_hub_faq4_a", locale)
	if (locale === "en") return en_bmi_hub_faq4_a(inputs)
	if (locale === "es") return es_bmi_hub_faq4_a(inputs)
	if (locale === "de") return de_bmi_hub_faq4_a(inputs)
	if (locale === "nl") return nl_bmi_hub_faq4_a(inputs)
	if (locale === "fr") return fr_bmi_hub_faq4_a(inputs)
	if (locale === "it") return it_bmi_hub_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_bmi_hub_faq4_a(inputs)
	if (locale === "pt") return pt_bmi_hub_faq4_a(inputs)
	if (locale === "ja") return ja_bmi_hub_faq4_a(inputs)
	return zh_bmi_hub_faq4_a(inputs)
};